import { cva } from 'class-variance-authority';

export const cvaSpinnerContainer = cva([
  'LoadingSpinnerStyles-cvaSpinnerContainer',
  // 'absolute -translate-x-1/2 left-1/2 top-1/2 -translate-y-1/2',
]);

export const cvaSpinner = cva(
  [
    'LoadingSpinnerStyles-cvaSpinner',
    'animate-[spin_1s_linear_infinite] block mx-auto',
  ],
  {
    variants: {
      color: {
        white: ['fill-white'],
        green: ['fill-cGreen '],
      },
      size: {
        default: ['w-3.4'],
        button: ['w-3'],
        small: ['w-2.8'],
      },
    },
    defaultVariants: {
      color: 'white',
      size: 'default',
    },
  }
);
